import {Controller} from '@hotwired/stimulus';

/**
 * Tuile de réglage qui dit la valeur choisie dans son panneau : le libellé suit le choix d'une combobox à choix
 * unique (`combobox:change`), écrit d'après `format` (« Catégorie : {name} »). L'option `rootValue` (la racine du
 * module, « Aucune catégorie » dans la liste) s'écrit `rootName` (« Pages ») : la page est rangée à la racine.
 *
 *   <div {{ stimulus_controller('tile-value', {format: '…'}) }} data-action="combobox:change->tile-value#update">
 *     <span {{ stimulus_target('tile-value', 'label') }}>…</span>
 */
export default class extends Controller {
  static targets = ['label'];

  static values = {format: String, rootValue: String, rootName: String};

  update({detail}) {
    // une combobox multiple (raccourcis) émet `values`, sans nom
    if (detail.name === undefined || detail.name === '') {
      return;
    }

    const root = this.hasRootValueValue && detail.value === this.rootValueValue && !detail.created;
    const name = root ? this.rootNameValue : detail.name;

    this.labelTarget.textContent = this.formatValue.replace('{name}', () => name);
  }
}
